import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable()
export class CookiesAcceptedService {
    private cookiesAcceptedSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(undefined);

    public get acceptCookies$(): Observable<boolean> {
        return this.cookiesAcceptedSubject.asObservable();
    }

    public acceptCookies = (accept: boolean): void => {
        this.cookiesAcceptedSubject.next(accept);
    }
}
